import { React, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/actions";
import { aboutus } from "../../redux/selectors";

const Aboutus = () => {
  const dispatch = useDispatch();
  const data = useSelector(aboutus("about_us"));
  const statistics = data?.en?.statistics;
  const board_member = data?.en?.grid.find(
    (item) => item.attributes?.title === "Board Members"
  )?.attributes?.members;
  const management_members = data?.en?.grid.find(
    (item) => item.attributes?.title === "Management"
  )?.attributes?.members;

  const vis_mis = data?.en?.values ?? [];
  const { our_values, mission } = vis_mis.reduce(
    (acc, item) => {
      if (item?.attributes?.image) {
        acc.our_values.push(item);
      } else {
        acc.mission.push(item);
      }
      return acc;
    },
    { our_values: [], mission: [] }
  );

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchData("about_us", "pages?path=/company-info/about-us"));
    }
  }, [dispatch, data]);

  return (
    <section className="hot-deals pt-80">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">
              About <b>Us</b>
            </h5>
          </div>
        </div>
        <div className="row g-12">
          <div className="col-md-4">
            <div>
              <p>
                Dhofar Global is the leading provider of essential products for
                businesses in the United Arab Emirates, Oman and Qatar.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* component 2 values*/}
      <br></br>
      <div className="short-product">
        <div className="container container-lg">
          <div className="row gy-4">
            {statistics &&
              statistics.length > 0 &&
              statistics.map((val, index) => (
                <div key={index} className="col-xxl-3 col-lg-4 col-sm-6">
                  <div className="p-16 rounded-16 position-relative transition-2 ">
                    <div className="short-product-list arrow-style-two">
                      <div>
                        <div className="flex-align gap-16 mb-40">
                          <div className="product-card__content mt-12">
                            <h1>{val?.attributes?.value}</h1>
                            <div className="product-card__price flex-align gap-8">
                              <h3>{val?.attributes?.title}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <br></br>
      {/* componant 3 vision mission*/}
      <div className="container container-lg">
        <div className="row gy-4">
          {mission &&
            mission.map((title, index) => (
              <div key={index} className="col-sm-6">
                <div className="offer-card position-relative rounded-16   overflow-hidden p-16 flex-align gap-16 flex-wrap z-1">
                  <div className="py-xl-4">
                    <h4 className="text-black mb-8 center">
                      {title?.attributes?.title}
                    </h4>
                    <hr></hr>
                    <p className="text-blue mb-8">
                      <b>{title?.attributes?.description}</b>
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <br></br>
      {/* componant 4 Our Values*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">Our Values</h5>
          </div>
        </div>
        <div className="row g-12">
          <div className="col-xxl-8">
            <div className="row gy-4">
              {our_values &&
                our_values.length > 0 &&
                our_values.map((name, index) => {
                  if (name?.layout === "image_value") {
                    return (
                      <div key={index} className="col-md-6">
                        <div className="p-16 border border-gray-100 hover-border-main-600 product-card style-two h-100  rounded-16 position-relative transition-2 flex-align gap-16">
                          <div className="">
                            <Link to="/product-details">
                              <img
                                src={name?.attributes?.image?.files?.small?.url}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div className="product-card__content">
                            <h6>{name?.attributes?.title}</h6>
                            <p>{name?.attributes?.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null; // Ensures that map() always returns something
                })}
            </div>
          </div>
        </div>
      </div>
      <br></br>
      {/* component 5 Governance*/}
      <div className="delivery-section">
        <div className="container container-lg center   ">
          <div className="delivery position-relative rounded-16 bg-main-600 p-16 flex-align gap-16 flex-wrap z-1">
            <div className="row align-items-center">
              <div className="col-md-3 d-md-block d-none"></div>
              <div className="col-md-6 col-sm-7 ">
                <div className="text-center">
                  <h4 className="text-white mb-8">{data?.en?.title}</h4>
                  <p className="text-white">{data?.en?.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* component 6 Board Members*/}
      <div className="container container-lg">
        <div className="tab-content" id="pills-tabContent">
          <h5 className="mb-0">Board Members</h5>
          <hr></hr>
          <div
            className="tab-pane fade show active"
            id="pills-all"
            role="tabpanel"
            aria-labelledby="pills-all-tab"
          >
            <div className="row g-12">
              {board_member &&
                board_member?.length > 0 &&
                board_member.map((member, index) => (
                  <div
                    key={index}
                    className="col-xxl-2 col-lg-3 col-sm-4 col-6 d-flex"
                  >
                    <div className="product-card d-flex flex-column h-100 p-8 border border-blue-100 hover-border-main-600 rounded-16 position-relative transition-2">
                      <Link
                        to="/product-details"
                        className="product-card__thumb flex-center"
                      >
                        <img
                          src={member?.attributes?.image?.files?.small?.url}
                          alt=""
                        />
                      </Link>
                      <div className="flex-align gap-6 mt-3">
                        <span className="text-main-600 text-md d-flex">
                          <Link
                            to={member?.attributes?.linkedin}
                            className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                          >
                            <i className="ph-fill ph-linkedin-logo" />
                          </Link>
                        </span>
                        <span className="text-l">
                          {member?.attributes?.full_name}
                        </span>
                      </div>
                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        {member?.attributes?.position}
                      </h6>
                      <p>{member?.attributes?.description}</p>

                      {/* Push this content to the bottom */}
                      <div className="product-card__content p-sm-2 mt-auto"></div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* component 7 Management*/}
      <br></br>
      <div className="short-product">
        <div className="container container-lg">
          <h5 className="mb-0">Management</h5>
          <hr></hr>
          <div className="row gy-4">
            {board_member &&
              management_members?.length > 0 &&
              management_members.map((member, index) => (
                <div key={index} className="col-xxl-3 col-lg-4 col-sm-6">
                  <div className="product-card d-flex flex-column h-100 p-8 border border-blue-100 hover-border-main-600 rounded-16 position-relative transition-2">
                    <Link
                      to="/product-details"
                      className="product-card__thumb flex-center"
                    >
                      <img
                        src={member?.attributes?.image?.files?.small?.url}
                        alt=""
                      />
                    </Link>
                    <div className="flex-align gap-6 mt-3">
                      <span className="text-main-600 text-md d-flex">
                        <Link
                          to={member?.attributes?.linkedin}
                          className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                        >
                          <i className="ph-fill ph-linkedin-logo" />
                        </Link>
                      </span>
                      <span className="text-l">
                        {member?.attributes?.full_name}
                      </span>
                    </div>
                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                      {member?.attributes?.position}
                    </h6>
                    <p>{member?.attributes?.description}</p>

                    {/* Push this content to the bottom */}
                    <div className="product-card__content p-sm-2 mt-auto"></div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <br></br>
    </section>
  );
};

export default Aboutus;
